export const SET_INCOGNITO_MODE = "SET_INCOGNITO_MODE";

export const setIncognitoMode = (response) => {
  return {
    type: SET_INCOGNITO_MODE,
    payload: response,
  };
};
